module.exports = __webpack_public_path__ + "img/ACCORDION_TEXT.0ef25b53.svg";